'use client'
import tailwindConfig from '@tailwind.config'
import Image from 'next/image'

import { MdBeachAccess } from "react-icons/md";
import { FaWater } from "react-icons/fa";
import { IoMdVideocam } from 'react-icons/io'
import { BiArea, BiSolidArea } from "react-icons/bi";
import { FaBed, FaBath } from "react-icons/fa"
// import { sendLike } from '@services/sendLike'
import CurrencySymbol from '@components/CurrencySymbol'

import LinkComponent from '@components/LinkComponent'

const LoadingCard = ({ imageWidth = 300, imageHeight = 200 }) => {
    const style = {
        color: tailwindConfig.theme.extend.colors.secondary,
        height: 90,
        overflow: 'hidden',
        z: 10
    };


    return (
        <div className={`sm:w-[${imageWidth}px] w-full sm:h-[480px] h-full overflow-hidden rounded-lg shadow-md hover:shadow-sm hover:shadow-maincolor`}

        >
        <Image
            className='sm:w-[300px] w-full aspect-[4/3] rounded-t-md overflow-hidden'
            src={'/images/placeholder.avif'}
            width={imageWidth}
            height={imageHeight}

        />

                    <div className='sm:w-[300px] w-full p-2'>
                        <div width={imageWidth} className='text-xl font-semibold text-maincolor relative flex flex-col justify-between sm:overflow-hidden sm:h-[85px] h-full'>
                            <div className='flex flex-col gap-1 sm:h-[85px] h-full'>
                                <div className='flex h-6 bg-gray-300 rounded-md animate-pulse items-center justify-center'></div>
                                <div className='flex h-6 bg-gray-300 rounded-md animate-pulse items-center justify-center'></div>
                                <div className='sm:flex hidden h-6 bg-gray-300 rounded-md animate-pulse items-center justify-center'></div>
                            </div>
                        </div>
                        <div className='flex flex-col h-[60px] gap-2'>
                            <div className='flex flex-row justify-between w-full gap-2 sm:mt-0 mt-2'>
                                    <div className='w-1/5 flex h-6 bg-maincolor/30 rounded-md animate-pulse items-center justify-center'></div>
                                    <div className='w-1/2 flex h-6 bg-third/70 rounded-md animate-pulse items-center justify-center'></div>
                            </div>
                            <div className='flex flex-row justify-between w-full gap-2 sm:mt-0 mt-2'>
                                    <div className='w-1/5 flex h-6 bg-maincolor/30 rounded-md animate-pulse items-center justify-center'></div>
                                    <div className='w-1/2 flex h-6 bg-third/70 rounded-md animate-pulse items-center justify-center'></div>
                            </div>
                        </div>
                        <div className='w-2/3 flex h-6 bg-gray-300 rounded-md animate-pulse items-center justify-center'></div>
                        <div className='w-full border-b-[1px] border-forth pb-1 mb-1'>
                        </div>
                        <div className='flex flex-col w-full gap-2'>
                            <div className='flex flex-row gap-2 w-full'>
                                <div className='flex w-1/2 h-6 bg-gray-300 rounded-md animate-pulse items-center justify-center'></div>
                                <div className='flex w-1/2 h-6 bg-gray-300 rounded-md animate-pulse items-center justify-center'></div>
                            </div>
                            <div className='flex flex-row gap-2 w-full'>
                                <div className='flex w-1/2 h-6 bg-gray-300 rounded-md animate-pulse items-center justify-center'></div>
                                <div className='flex w-1/2 h-6 bg-gray-300 rounded-md animate-pulse items-center justify-center'></div>
                            </div>
                        </div>
                    </div>
        </div>
    )
}

export default LoadingCard